import React, { useEffect, useState, useContext, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import { useTranslation } from "react-i18next";
import { connectionToProvider } from "../../service/ConnectionServices";
import {
  getHopitalsList,
  changeStatusClient,
  changeFirmStatus,
} from "../../service/FirmServices";
import ColumnsClient from "./ColumnsClient";
import ModalMain from "../../components/Modal/ModalMain";
import Connection from "./Connection";
import ModalFooter from "../../components/Modal/ModalFooter";
import ModalHeader from "../../components/Modal/ModalHeader";
import userContext from "../../context/users/UserContext";
import { PrimaryButton } from "@fluentui/react";
import loaderContext from "../../context/loader/LoaderContext";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";

const ClientList = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const { roles, loadByUsername, authenticated } = useContext(userContext);
  const [dataQueryState, setDataQueryState] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [code, setCode] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [isConnectionSuccessfull, setIsConnectionSuccessfull] = useState(false);
  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const fetchClientList = async (options) => {
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await getHopitalsList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        if (response.data.data.loggedInUserRole === USERTYPES.ADMIN) {
          data = response.data.data.results.content;
          pageCount = response.data.data.results.totalPages;
        } else {
          data = response.data.data.clientPage.content;
          pageCount = response.data.data.clientPage.totalPages;
        }
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  function ReloadData(id) {
   // setUpdateCurrentPage(() => !updateCurrentPage);
   // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == id) {
        newIndex = index;
        return true;
      }
      return false;
    });  
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState
      };
      if(newValue.data.rows[newIndex] != null){
        if(newValue.data.rows[newIndex].status == "Active"){
          newValue.data.rows[newIndex].status = "Inactive"; 
        }else{
          newValue.data.rows[newIndex].status = "Active"; 
        }
      }
      return newValue;
    });

  }

  const handleClickGroup = async (event, data, cell) => {
    event.stopPropagation();
    let response;
    try {
      if (roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.RADIOLOGIST) {
        response = await changeStatusClient(
          cell.row.original.connectionId,
          "CLIENT",
          cell.row.original.firmActive ? false : true
        );
      } else if (roles[0] === USERTYPES.ADMIN) {
        response = await changeFirmStatus(cell.row.original.id);
      }
      if (response.status === 200 && response.data.result === "SUCCESS") {
        ReloadData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setCode("");
    setErrorMsg("");
    setSuccess(false);
    setSuccessMsg("");
  }, [isModalOpen]);

  useEffect(() => {
    if (success && !isModalOpen) {
      setUpdateCurrentPage(() => !updateCurrentPage);
      setFilterObj({
        ...filterObj,
        activeStatus: updateCurrentPage,
        row: null,
      });
    }
  }, [success, isModalOpen]);

  const connect = async () => {
    if (code.length == 0) {
      setErrorMsg(t("hospital.firm-code-required"));
      return;
    } else {
      setErrorMsg("");
    }
    setLoading(true);
    const body = {
      connectionDto: {
        id: null,
        clientId: null,
        providerId: null,
        radiologistId: null,
        status: null,
        onPayroll: null,
        qcRadiologist: 0,
        codeRadiologist: null,
        firmCodeProvider: null,
        firmCodeClient: code,
        currentUserId: null,
        showAllStudies: 0,
        qcEnabled: 0,
        twoSignaturesAllowed: 0,
        modalityIds: null,
      },
    };
    try {
      setLoaderRunning(true);
    ref.current.continuousStart();
      const response = await connectionToProvider(body, false);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setIsConnectionSuccessfull(true);
        setSuccessMsg(response.data.message);
        setSuccess(true);
        setLoaderRunning(false);
        ref.current.complete();
      } else if (
        response.status === 200 &&
        response.data.result === "FAILURE"
      ) {
        const res = response.data.data.errors;
        if (res.length > 0) {
          setErrorMsg(res[0].defaultMessage);
        }
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (roles[0] != USERTYPES.RADIOLOGIST) {
      navigate(AuthRoutes.FIRMDETAILS + "?firmId=" + cell.id + "&type=" + 0
      // , {
        // state: {
        //   firmId: cell.id,
        //   type: 0,
        //   hospital: false,
        //   action: ACTIONS.VIEW,
        // },
      // });
      )
    }
  };

  const columns = ColumnsClient(handleClickGroup, roles[0]);

  const options = [
    { key: "name", text: "Name" },
    { key: "address", text: "Address" },
    { key: "email", text: "Email" },
    // { key: "mobile", text: "Mobile" },
    { key: "action", text: "Action" },
  ];

  const buttonsTopBar = [
    (roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.RADIOLOGIST)  && {
      key: "1",
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            setIsConnectionSuccessfull(false);
            setModalOpen(true);
          }}
        >
          <PrimaryButton text={t("button.connect")} className={"common-default-active-button list-view-top-buttons-styles"} />
        </div>
      ),
    },
    roles[0] != USERTYPES.RADIOLOGIST && roles[0] != USERTYPES.FIRMDOCTOR && roles[0] != USERTYPES.FIRMTECHNICIAN  && {
      key: "2",
      button: (
        <Link
          key="2"
          to={AuthRoutes.ADDHOSPITAL}
          state={{ action: ACTIONS.ADD }}
        >
          <div className="add-button-list-view">
            <PrimaryButton text={t("button.new-hospital")} className={"common-default-active-button list-view-top-buttons-styles"} />
          </div>
        </Link>
      ),
    },
    roles[0] != USERTYPES.RADIOLOGIST && roles[0] != USERTYPES.FIRMDOCTOR && roles[0] != USERTYPES.FIRMTECHNICIAN && {
      key: "3",
      button: (
        <Link
          key="3"
          to={AuthRoutes.ADDTELERADIOLOGYCENTRE}
          state={{ action: ACTIONS.ADD }}
        >
          <div className="add-button-list-view">
            <PrimaryButton text={t("button.new-tele-center")} className={"common-default-active-button list-view-top-buttons-styles"} />
          </div>
        </Link>
      ),
    },
    roles[0] != USERTYPES.RADIOLOGIST && roles[0] != USERTYPES.FIRMDOCTOR && roles[0] != USERTYPES.FIRMTECHNICIAN && {
      key: "4",
      button: (
        <Link
          key="4"
          to={AuthRoutes.ADDIMAGINGCENTRE}
          state={{ action: ACTIONS.ADD }}
        >
          <div className="add-button-list-view">
            {/* <AddButton text="New Imaging Center" /> */}
            <PrimaryButton text={t("button.new-imaging-center")} className={"common-default-active-button list-view-top-buttons-styles"} />
          </div>
        </Link>
      ),
    },
  ];

  const hideConnectionModal = () => {
    setModalOpen(false);
  };

  let PrimaryButtonList = [
    {
      title: t("button.connect"),
      onclick: connect,
    },
  ];
  let DefaultButtonList = [
    {
      title: isConnectionSuccessfull ? t("button.close") : t("button.cancel"),
      onclick: hideConnectionModal,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        showPatientDetails={false}
        heading={isConnectionSuccessfull ? t("confirm-message.alert") : t("hospital.connect-client")}
        handleCancel={hideConnectionModal}
      />
    ),
    body: (
      <Connection
        isRadiologistModalOpen={false}
        success={success}
        successMsg={successMsg}
        label={t("hospital.firm-code")}
        setCode={setCode}
        code={code}
        setErrorMsg={setErrorMsg}
        errorMsg={errorMsg}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={!isConnectionSuccessfull ? PrimaryButtonList : null}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "500px",
  };

  const handleApplyClick = (filterValue) => {
    if(filterValue != undefined)filterValue = filterValue.trim();
    setPagination(()=>{
      const newItem = {...paginationObj};
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(()=>{
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterInput = filterValue;
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
    },100);
  };

  return (
    <div className="main-container-body">
      {isModalOpen && (
        <ModalMain modalDetails={modalDetails} showModal={isModalOpen} />
      )}

      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={options}
        fetchData={fetchClientList}
        showSideBySide={false}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        handleApplyClick={handleApplyClick}
        paginationObj={paginationObj}
        unqiueKey={"Client"}
        placeholder={t("placeholder.firm-name")}
        pointer={roles[0] === USERTYPES.RADIOLOGIST ? false : true}
        heading={roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.RADIOLOGIST ? t("navbar.clients") : t("navbar.firms")}
      />
    </div>
  );
};

export default ClientList;
